import styled, { css } from 'styled-components';

export const YouTubeVideo = styled.div`
  p {
    padding: 30px 16px 0;
    font-size: clamp(16px, 3vw, 20px);
    color: rgb(0 0 0 / 80%);
    letter-spacing: 2px;
    font-weight: 600;
  }
`;

export const DiaperVideo = styled.video`
  width: 100%;
  margin: ${(props) =>
    props.aboutSection ? '' : props.noMargin ? '30px 0 20px ' : '30px 0 -41px'};
  @media (min-width: 768px) {
    width: 95%;
    margin-left: 16px;
  }
`;

export const WhatsappBannerImage = styled.div`
  &.lowOpacity {
    opacity: 0.4;
  }

  position: relative;
  padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '42%')};
  margin: 16px 12px 0;

  @media (min-width: 720px) {
    max-width: ${(props) => (props.lactoMamaCategory ? '720px' : 'auto')};
    width: ${(props) => (props.lactoMamaCategory ? '100%' : 'auto')};
    height: ${(props) => (props.lactoMamaCategory ? '100%' : 'auto')};
    aspect-ratio: ${(props) => (props.lactoMamaCategory ? '9/4' : 'auto')};
    padding-top: ${(props) => (props.lactoMamaCategory ? '2%' : 'auto')};
  }
`;

export const NewRatingStyle = styled.div`
  width: 100%;

  ${(props) =>
    props.showNewRatingView &&
    css`
      background-color: #fcfbf5;
      padding: 15px;
    `}

  .rating-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .rating-item-outer {
    display: flex;
    gap: 6px;
  }

  .rating-item {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .rating-label {
    flex-basis: 27%;
    flex-shrink: 0;
    color: ${(props) =>
      props.showNewRatingView ? 'rgba(0, 0, 0, 0.70);' : '#68b0a8'};
    font-size: ${(props) =>
      props.showNewRatingView ? '14px' : 'clamp(10px, 2vw, 15px)'};
    font-weight: ${(props) => (props.showNewRatingView ? 500 : 600)};
    text-transform: capitalize;
    text-align: left;
    @media (min-width: 720px) {
      flex-basis: 30%;
    }
  }

  .rating-bar {
    flex-basis: ${(props) => (props.showNewRatingView ? '18%' : '20%')};
    flex-shrink: 0;
    display: flex;
    height: ${(props) => (props.showNewRatingView ? '6px' : '8px')};
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    overflow: hidden;
    position: relative;
    background-color: ${(props) => (props.showNewRatingView ? '#ececec' : '')};

    &:first-child {
      border-radius: 5px 0 0 5px;
    }

    &:last-child {
      border-radius: 0px 5px 5px 0px;
    }

    @media (min-width: 720px) {
      height: 10px;
    }
  }

  .rating-fill {
    height: 100%;
    background-color: ${(props) =>
      props.showNewRatingView ? '#87ab66' : '#68b0a8'};
    transition: width 0.3s ease-in-out;
  }

  .rating-value {
    flex-basis: 15%;
    @media (min-width: 720px) {
      flex-basis: 12%;
    }
    font-size: ${(props) =>
      props.showNewRatingView ? '16px' : 'clamp(10px, 2vw, 15px)'};
    margin-left: auto;
    font-weight: 600;
    color: ${(props) =>
      props.showNewRatingView ? 'rgba(0, 0, 0, 0.57);' : '#68b0a8'};
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: end;
    letter-spacing: 1px;

    span {
      font-size: 13px;
      font-weight: 400;
    }
  }
`;
